module.exports = require("././angular-messages.js");


//////////////////
// WEBPACK FOOTER
// angular-messages (bower component)
// module id = 1419
// module chunks = 1